
import { motion } from 'framer-motion';

export default function AboutHero() {
  return (
    <section className="relative h-[85vh] min-h-[600px] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2c91425ae37308daa398e30c8e76a63b.jpg"
          alt="EUREKA - O Firmie"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-[#050505]"></div>
      </div>

      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 w-full">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <span
              className="text-[#00E5FF] text-xs sm:text-sm tracking-[0.3em] uppercase font-semibold"
              style={{ fontFamily: 'Orbitron, sans-serif' }}
            >
              O Firmie
            </span>
            <div className="h-[2px] w-16 bg-[#00E5FF] mt-3 mb-6"></div>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="text-4xl sm:text-5xl md:text-7xl font-bold text-white leading-tight max-w-4xl"
            style={{ fontFamily: 'Rajdhani, sans-serif' }}
          >
            Ponad 35 Lat<br />
            <span className="text-[#00E5FF]">Precyzji</span> i Niezawodności
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.4 }}
            className="text-base sm:text-lg text-[#C0C7CF] mt-6 max-w-2xl leading-relaxed"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Od małej firmy handlowej w 1989 roku do uznanego producenta konstrukcji
            stalowych dla największych koncernów przemysłowych w Polsce.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.6 }}
            className="flex flex-wrap gap-8 sm:gap-12 mt-10 sm:mt-14"
          >
            {[
              { value: '1989', label: 'Rok założenia' },
              { value: '35+', label: 'Lat doświadczenia' },
              { value: '19', label: 'Ekspertów' },
              { value: '200+', label: 'Realizacji' },
            ].map((stat, i) => (
              <div key={i} className="text-center sm:text-left">
                <div
                  className="text-2xl sm:text-3xl font-bold text-[#00E5FF]"
                  style={{ fontFamily: 'Orbitron, sans-serif' }}
                >
                  {stat.value}
                </div>
                <div
                  className="text-[#C0C7CF] text-[10px] sm:text-xs tracking-wider uppercase mt-1"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {stat.label}
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.2 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20"
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="w-8 h-8 flex items-center justify-center cursor-pointer"
        >
          <i className="ri-arrow-down-line text-2xl text-[#00E5FF]"></i>
        </motion.div>
      </motion.div>
    </section>
  );
}
